import { Typography } from '@mui/material'
import { Children, ReactNode } from 'react'

type GroupItemsSectionProps = {
  title: string
  header?: ReactNode
  children: ReactNode
}

export function GroupItemsSection({
  title,
  header,
  children,
}: GroupItemsSectionProps) {
  return (
    <section>
      <div className="flex justify-between">
        <Typography variant="h2" className="mb-8">
          {title}
        </Typography>
        {header}
      </div>
      <ul className="grid grid-flow-row-dense grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {Children.map(children, (child, index) => (
          <li key={index}>{child}</li>
        ))}
      </ul>
    </section>
  )
}
